import { palette } from "@passfirst/ui";

// Shared shape for every icon in the library. Each icon takes size +
// color + strokeWidth; defaults below are theme-invariant palette
// values (brand navy is the same hex in both themes; grey-500 reads
// well as a "muted" tone on either ground).
export interface IconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

// Theme-invariant defaults so icons don't have to call useColors() on
// every render — one hook per icon × many icons per screen is wasteful.
// Callers nearly always pass an explicit color anyway.
export const DEFAULT_BRAND = palette.navy;
export const DEFAULT_MUTED = palette.grey500;

// Standard 24×24 viewBox + size frame. All icons render at viewBox
// 0 0 24 24 so paths compose consistently across the library.
export function frame({ size = 24 }: { size?: number }): {
  width: number;
  height: number;
  viewBox: string;
} {
  return { width: size, height: size, viewBox: "0 0 24 24" };
}
